export default "__VITE_ASSET__7VzqF0H9__"